import { useEffect, useRef, useState } from "react"
import "trix"

import { Button, InfoMessage } from "web/components"

export default function Modal({
  trixEditorId = "trix",
  value,
  source,
  handleSave,
  handleClear,
  readOnly = false,
  disableAfterClick = false,
}) {
  const editorRef = useRef()
  const editorWrapperRef = useRef()
  const inputRef = useRef()

  const displayingOtherSource = !!source && source.type !== "Account"

  const displayOtherSourceWarningMessage = displayingOtherSource

  const [draftContent, setDraftContent] = useState(value || "")

  useEffect(
    () => {
      const trix = editorRef.current
      const trixToolbar =
        editorWrapperRef.current.querySelectorAll("trix-toolbar")[0]

      trix.setAttribute("contentEditable", !readOnly)

      if (readOnly) {
        trixToolbar.style.display = "none"
      } else {
        trix.focus()
      }

      const updateDraftContent = () => {
        setDraftContent(inputRef.current.value)
      }
      const cancelFileAccept = (e) => {
        e.preventDefault()
      }

      trix.addEventListener("trix-change", updateDraftContent)
      trix.addEventListener("trix-file-accept", cancelFileAccept)

      return () => {
        trix.removeEventListener("trix-change", updateDraftContent)
        trix.removeEventListener("trix-file-accept", cancelFileAccept)
      }
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return (
    <>
      <div className="modal-content-above-commands">
        {displayOtherSourceWarningMessage && (
          <InfoMessage
            title={`Displaying content from: ${source.name}`}
            className="mb-4"
          >
            Your changes will take precedence over this content, but you not
            overwrite it.
          </InfoMessage>
        )}
        <div
          ref={editorWrapperRef}
          className="prose h-full max-w-none [&_.trix-button--icon-code]:hidden [&_.trix-button-group--file-tools]:hidden [&_.trix-button-row]:overflow-x-visible"
        >
          <input type="hidden" id={trixEditorId} ref={inputRef} value={value} />
          <trix-editor
            class={`trix-content ${readOnly ? "border-none" : "h-[calc(100%-40px)] overflow-auto rounded-md border border-neutral-8 focus:outline-none"}`}
            input={trixEditorId}
            ref={editorRef}
            placeholder="Write something..."
          />
        </div>
      </div>
      {!readOnly && (
        <div className="modal-commands">
          <div className="left-buttons">
            <Button variant="secondary_default" onClick={handleClear}>
              Clear
            </Button>
          </div>
          <div className="right-buttons">
            <Button
              disableAfterClick={disableAfterClick}
              onClick={() => handleSave(draftContent)}
            >
              Save
            </Button>
          </div>
        </div>
      )}
    </>
  )
}
